import React, {useEffect, useState} from "react";
import cinnamon from "../Accests/images/spices/cinnamon.jpg"
import oil from "../Accests/images/spices/cinnamon-oil.jpg"
import enasal from "../Accests/images/spices/enasal.jpg"
import karabu from "../Accests/images/spices/karabu.jpg"
import Saddikka from "../Accests/images/spices/Sadikka.jpg"
import gammiris from "../Accests/images/spices/gammiris.jpg"
import tea from "../Accests/images/spices/tea.jpg"
import coffe from "../Accests/images/spices/coffe.jpg"
import samahan from "../Accests/images/spices/samahan.jpg"
import eramusu from "../Accests/images/spices/eramusu.jpg"
import belimal from "../Accests/images/spices/ranawara.jpg"
import ranawara from "../Accests/images/spices/belimal.jpg"
import nelli from "../Accests/images/spices/nellinew.png"
import kottamalli from "../Accests/images/spices/kottamalli.jpg"
import s10 from "../Accests/images/spices/s10.jpg"
import s30 from "../Accests/images/spices/s30.jpg"
import s100 from "../Accests/images/spices/s100.jpg"
import kaha from "../Accests/images/spices/kaha.jpg"
import bovitiya from "../Accests/images/spices/bovitiya.jpg"
import rasakida from "../Accests/images/spices/rasakida.jpg"
import rathu from "../Accests/images/spices/rathuu.jpg"
import sudu from "../Accests/images/spices/sudu.jpg"
import Rathu from "../Accests/images/spices/Rathu.jpg"
import sidda from "../Accests/images/spices/sidda.jpg"
import signal from "../Accests/images/spices/signal.jpg"
import Tippili from "../Accests/images/spices/tippili.jpg"
import kothala from "../Accests/images/spices/kotala.jpeg"
import hadun from "../Accests/images/spices/hadunn.jpeg"
import BottomActionBar from "./BottomActionBar";


const products = {
    spices: [
        {name: "Cinnamon Stick (100g)", price: "7€", img: cinnamon},
        {name: "Cinnamon Oil (Small Bottle)", price: "5€", img: oil},
        {name: "Cardamom (Fresh Green, 100g)", price: "10€", img: enasal},
        {name: "Clove (100g)", price: "5€", img: karabu},
        {name: "Nutmeg (per piece)", price: "0.24€", img: Saddikka},
        {name: "Black Pepper (100g)", price: "1€", img: gammiris},
        {name: "Turmeric Powder (50g)", price: "1€", img: kaha},
    ],
    tea: [
        {name: "High-Quality Tea", price: "Price varies", img: tea},
        {name: "Low-Quality Tea", price: "Price varies", img: tea},
        {name: "Coffee Beans (1kg)", price: "33€", img: coffe},
    ],
    herbalTeas: [
        {name: "Samahan (1 packet)", price: "0.20€", img: samahan},
        {name: "Erumusu (10 tea bags)", price: "0.76€", img: eramusu},
        {name: "Belimal (10 tea bags)", price: "0.76€", img: belimal},
        {name: "Ranawara (10 tea bags)", price: "0.43€", img: ranawara},
        {name: "Nelli Rasakinda (10 tea bags)", price: "0.46€", img: nelli},
        {name: "Coriander (100g)", price: "0.46€", img: kottamalli},
        {name: "Welmee (100g)", price: "0.75€", img: rasakida},
        {name: "heen bovitiya", price: "2€", img: bovitiya},
        {name: "Tippili", price: "1€", img: Tippili},
        {name: "Kothala Himbatu (10 tea bags)", price: "0.76€", img: kothala}
    ],
    samahanBulk: [
        {name: "10 Packets (1 Box)", price: "2€", img: s10},
        {name: "30 Packets (1 Box)", price: "6€", img: s30},
        {name: "100 Packets (1 Box)", price: "20€", img: s100},
    ],
    cosmetic: [

        {name: "Red Sandalwood Oil (450ml) / Wood (25g) ", price: "45€ / 1€", img: rathu},
        {name: "Red Sandalwood Powder (25g)", price: "1€", img: Rathu},
        {name: "White Sandalwood Oil (450ml) / Powder (25g) / Wood (25g)", price: "45€/1€/1€", img: sudu},

    ],
    HerbalProducts: [

        {name: "Herbal Balm", price: "2.75€", img: sidda},
        {name: "Herbal Toothpaste", price: "1€", img: signal},
        {name: "Insane", price: "1€", img: hadun},

    ]
};

const ProductCard = ({ name, price, img }) => (
    <div
        data-aos="zoom-in"
        className="relative group bg-white rounded-2xl shadow-md p-4 flex flex-col items-center text-center hover:z-10"
    >
        <img src={img} alt={name} className="w-28 h-28 object-cover rounded-lg mb-2" />
        <h3 className="font-semibold text-sm">{name}</h3>
        <p className="text-green-600 font-bold mt-1">{price}</p>

        {/* Popup on hover */}
        <div
            className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 w-52 bg-white text-gray-800 rounded-lg shadow-lg p-3 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            <img src={img} alt={name} />
            <p className="font-semibold">{name}</p>
            <p className="text-green-600 font-bold">{price}</p>
        </div>
    </div>
);


const Section = ({title, items}) => (
    <div className="mt-20 lg:mt-18 mb-8">
        <h2 className="text-xl font-bold text-green-800 mb-4">{title}</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {items.map((item, idx) => (
                <ProductCard key={idx} {...item} />
            ))}
        </div>
    </div>
);


const HerbalProductList = () => {


    const [showActionBar, setShowActionBar] = useState(true);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);



    return (

        <>
            <BottomActionBar visible={showActionBar} />

        <div className="max-w-7xl mx-auto px-4 py-8 bg-green-50 min-h-screen mt-24 lg:mt-18">
            <h1 className="text-3xl font-bold text-center text-green-900 mb-10">
                🌿 Spices, Tea & Herbal Products
            </h1>

            <Section title="🌿 Spices & Herbs" items={products.spices}/>
            <Section title="🍵 Tea & Coffee" items={products.tea}/>
            <Section title="🍃 Herbal Teas" items={products.herbalTeas}/>
            <Section title="📦 Samahan Bulk Packs" items={products.samahanBulk}/>
            <Section title="💄 Cosmetic" items={products.cosmetic}/>
            <Section title="🌿 Herbal Products" items={products.HerbalProducts}/>
        </div>

        </>
    );
};

export default HerbalProductList;
